import { ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';

import { agGridLicenseKey } from 'components/Grid/license';

// AG Grid global setup. Imported once at app entry (src/index.jsx) so it runs
// before any grid mounts.
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

// v33+ requires explicit module registration. AllEnterpriseModule mirrors the
// previous side-effect `import 'ag-grid-enterprise'` (full enterprise bundle),
// so no feature can hit a missing-module runtime error.
ModuleRegistry.registerModules([AllEnterpriseModule]);

// Keep the legacy CSS themes (ag-theme-balham base + ag-theme-fleetops override
// layer) rather than opting into the v33 Theming API. This preserves the
// existing look exactly.
//
// Don't set suppressBrowserResizeObserver: since v32.2 the grid always uses the
// browser's ResizeObserver, so the option has no effect and only logs a
// deprecation warning.
provideGlobalGridOptions({
  theme: 'legacy',
  // Use the legacy column menu (hover hamburger via the header template's eMenu)
  // rather than v33+'s always-visible "⋮" ellipsis button, matching v31.
  columnMenu: 'legacy',
});

LicenseManager.setLicenseKey(agGridLicenseKey);
